
import { Headphones } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface RelatedPodcastsProps {
  podcasts: any[];
}

const RelatedPodcasts = ({ podcasts }: RelatedPodcastsProps) => {
  if (!podcasts.length) return null;

  return (
    <div className="mb-6">
      <h3 className="font-semibold text-nation-blue mb-3 flex items-center text-sm">
        <Headphones size={16} className="mr-2" />
        Related Podcasts
      </h3>
      <div className="space-y-4">
        {podcasts.map((podcast, index) => (
          <Card key={index}>
            <CardContent className="pt-4">
              <h4 className="text-sm font-medium mb-2">{podcast.title}</h4>
              <p className="text-sm text-muted-foreground mb-3">{podcast.description}</p>
              <iframe 
                src={`https://open.spotify.com/embed/episode/${podcast.episode_id || podcast.internal_url?.split('/').pop()}`}
                width="100%" 
                height="152" 
                frameBorder="0" 
                allow="encrypted-media"
                className="rounded-md"
              />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RelatedPodcasts;
